import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgCategoryFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { d: "M4 2a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4ZM4 13a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2H4ZM13 4a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V4ZM15 13a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-5a2 2 0 0 0-2-2h-5Z", fill: color }));
};
export default factorySvgIcon(SvgCategoryFilled);
//# sourceMappingURL=SvgCategoryFilled.js.map